import main from "./main";

const navigation = [...main];

export default navigation